import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class WattFlowMeter extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 247.56">
                <rect y={66.18} width={300} height={75.13} rx={2.83} ry={2.83} fill={color} />
                <circle cx={150} cy={103.75} r={100.62} fill={color} />
                <path
                    d="M150 207.5a103.75 103.75 0 1 1 103.75-103.72A103.87 103.87 0 0 1 150 207.5zm0-201.23a97.49 97.49 0 1 0 97.49 97.51A97.6 97.6 0 0 0 150 6.27z"
                    fill={secondaryColor}
                />
                <path
                    d="M256.11 167.29h-19.78l23.44-43.51a3.18 3.18 0 0 0-2.79-4.7h-62.35a3.18 3.18 0 0 0-3.17 3.18v66a3.18 3.18 0 0 0 3.17 3.18H196l14 .16v49.63a3.17 3.17 0 0 0 2.32 3.07 3 3 0 0 0 .86.12 3.18 3.18 0 0 0 2.72-1.53l42.86-70.77a3.18 3.18 0 0 0-2.71-4.84z"
                    fill={color}
                />
                <path
                    d="M213.25 247.56a6.12 6.12 0 0 1-1.74-.25 6.31 6.31 0 0 1-4.56-6.07v-46.53l-12.31-.12a6.32 6.32 0 0 1-6.3-6.32v-66a6.32 6.32 0 0 1 6.3-6.32H257a6.32 6.32 0 0 1 5.55 9.32l-21 38.87h14.54a6.32 6.32 0 0 1 5.4 9.59l-42.86 70.77a6.35 6.35 0 0 1-5.38 3.06zm-18.62-125.33v66l1.45.05 17.17.19v52.72l42.94-70.73v-.09h-25L257 122.31l-13.53-.08zM193.33 72.45h-86.66a6.265 6.265 0 0 1 0-12.53h86.65a6.265 6.265 0 1 1 0 12.53z"
                    fill={secondaryColor}
                />
            </svg>
        );
    }
}

export default withTheme(WattFlowMeter);



// WEBPACK FOOTER //
// ./data/common/iconsvg/WattFlowMeter.js